import React from 'react'
import {Icons} from '@xpertdox_js/xdcomponents'

export default class TooltipItem extends React.Component {
  constructor(props){
    super(props)
    this.state= {
      open: false,
      left: "auto",
      top: "auto"
    }
    this.setOpenAndPlace = this.setOpenAndPlace.bind(this)
    this.hide = this.hide.bind(this)
  }
  setOpenAndPlace(e){
    e.preventDefault()
    let toolTipItem = document.getElementById(`tooltip${this.props.index}`);
    let itemPos = toolTipItem.getBoundingClientRect()
    this.setState({
      open: true,
      left: itemPos.left+15,
      top: itemPos.top
    })
  }
  hide(e){
    e.preventDefault()
    this.setState({
      open:false
    })
  }
  render(){
    return (
      <span className='tooltipSpan' id={`tooltip${this.props.index}`} onMouseEnter={(e) => this.setOpenAndPlace(e)} onMouseLeave={(e) => this.hide(e)}>
        <Icons icon='info' style={{width: '15px', height: '15px'}} />
        <span style={{
          visibility: this.state.open === true ? 'visible' : 'hidden',
          opacity: this.state.open === true ? 1 : 0,
          left: this.state.left,
          top: this.state.top,
        }} className='tooltipContent'>{this.props.text}</span>
      </span>
    )
  }
}
